<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item"
    :class="{
      active: isActive,
      disabled: item.disabled,
    }"
  >
    <b-link
      v-bind="linkProps"
      :class="[
        isPadding ? 'item-menu' : 'item-menu-hide',
        'd-flex align-items-center text-justify-center',
      ]"
    >
      <!-- <MyBookingIcon /> -->

      <component
        v-if="ready(item.icon)"
        :class="{ ' fillWhite': isActive }"
        :is="item.icon"
      />
      <feather-icon v-else :icon="item.icon || 'CircleIcon'" />
      <!-- <img
        v-if="item.icon"
        v-lazy="
          `${require(`@/assets/images/icons/file-icons/${item.icon}.svg`)}`
        "
        :alt="item.title"
        class="img-fluid"
       
      /> -->
      <!-- <feather-icon :icon="'CircleIcon'" /> -->
      <span class="menu-title text-truncate">{{ t(item.title) }} </span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from "@core/libs/acl";
import { BLink, BBadge } from "bootstrap-vue";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import useVerticalNavMenuLink from "./useVerticalNavMenuLink";
import mixinVerticalNavMenuLink from "./mixinVerticalNavMenuLink";
import store from "@/store";
import { ref, computed } from "@vue/composition-api";
import EventBus from "@/EvenBus";
import MyBookingIcon from "@/assets/images/icons/file-icons/MyBookingIcon.svg?external";
import GuidelinesIcon from "@/assets/images/icons/file-icons/GuidelinesIcon.svg?external";
import HistoryIcon from "@/assets/images/icons/file-icons/HistoryIcon.svg?external";
import LocationIcon from "@/assets/images/icons/file-icons/LocationIcon.svg?external";
import MyProfileIcon from "@/assets/images/icons/file-icons/MyProfileIcon.svg?external";
import MyQuotationIcon from "@/assets/images/icons/file-icons/MyQuotationIcon.svg?external";
import PieChartIcon from "@/assets/images/icons/file-icons/PieChartIcon.svg?external";
import PrivacyPolicyIcon from "@/assets/images/icons/file-icons/PrivacyPolicyIcon.svg?external";
import PromotionIcon from "@/assets/images/icons/file-icons/PromotionIcon.svg?external";
import SailingScheduleIcon from "@/assets/images/icons/file-icons/SailingScheduleIcon.svg?external";
import SettingIcon from "@/assets/images/icons/file-icons/SettingIcon.svg?external";
import TrackAndTraceIcon from "@/assets/images/icons/file-icons/TrackAndTraceIcon.svg?external";
import UnpaidIcon from "@/assets/images/icons/file-icons/UnpaidIcon.svg?external";
import PaidIcon from "@/assets/images/icons/file-icons/PaidIcon.svg?external";

export default {
  components: {
    BLink,
    BBadge,
    MyBookingIcon,
    GuidelinesIcon,
    HistoryIcon,
    LocationIcon,
    MyProfileIcon,
    MyQuotationIcon,
    PieChartIcon,
    PrivacyPolicyIcon,
    PromotionIcon,
    SailingScheduleIcon,
    SettingIcon,
    TrackAndTraceIcon,
    UnpaidIcon,
    PaidIcon,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isPadding: true,
    };
  },
  computed: {},
  mounted() {
    EventBus.$on("isExpanded", this.setData);
  },
  methods: {
    setData(e) {
      this.isPadding = e;
    },
    ready(component) {
      console.log(component);

      return Object.keys(this.$options.components).includes(component);
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(
      props.item
    );

    const { t } = useI18nUtils();
    const { canViewVerticalNavMenuLink } = useAclUtils();

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    };
  },
};
</script>
